module.exports = __webpack_public_path__ + "static/media/20210409_192607_298_IMG_0059.dbbe9bdc.jpg";